import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getEquipmentRegistrations(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATIONS,
		options
	)
}

function _getEquipmentRegistration(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATION,
		options
	)
}

function _createEquipmentRegistration(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].CREATE_EQUIPMENT_REGISTRATION,
		options
	)
}

function _patchEquipmentRegistration(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PATCH_EQUIPMENT_REGISTRATION,
		options
	)
}

function _putEquipmentRegistration(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PUT_EQUIPMENT_REGISTRATION,
		options
	)
}

function _deleteEquipmentRegistration(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,
		ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].DELETE_EQUIPMENT_REGISTRATION,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATIONS]: _getEquipmentRegistrations,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATION]: _getEquipmentRegistration,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].CREATE_EQUIPMENT_REGISTRATION]: _createEquipmentRegistration,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PATCH_EQUIPMENT_REGISTRATION]: _patchEquipmentRegistration,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PUT_EQUIPMENT_REGISTRATION]: _putEquipmentRegistration,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].DELETE_EQUIPMENT_REGISTRATION]: _deleteEquipmentRegistration,
}
